import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';

import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/components/app-alert';
import { CustomerDetails } from '../../shared/models/customerDetails.model';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { EnvironmentService } from 'src/app/shared/services/environment.service';

//import { ModelPropertyViewComponent } from '../../shared/components/model-property-view/model-property-view.component'

@Component({
  selector: 'app-customer-page',
  templateUrl: './customer-page.component.html',
  styleUrls: [
    '../pages.sass',
    './customer-page.component.sass'
  ]
})
export class CustomerPageComponent implements OnInit {

  public activeTabId: string = 'requests';
  public customerId: string;
  public customer: any = {};
  public customerGroups: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: ApiService,
    private alert: AlertService,
    private modal: BsModalService,
    private environment: EnvironmentService
  ) { }

  ngOnInit(): void {
    const params = this.activatedRoute.snapshot.params;
    this.customerId = params.id;
    this.activeTabId = params.page;
    this.api.get(`customers/${params.id}`, (customer: CustomerDetails) => {
      this.customer = customer;
      this.customerGroups = customer.Groups.map(group => `${group.Name} (${group.SimType.Name})`).join(', ');
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const params = this.activatedRoute.snapshot.params;
        this.activeTabId = params.page;
      }
    });
  }

  onSelectTab(tab): void {
    this.router.navigate(['..', tab.id],
      {
        relativeTo: this.activatedRoute
      });
  }

  goToLink(url: string){
    window.open(url, "_blank");
  }

  updateDetails = (resultFunc?: (result: any) => void) => {
    this.api.put(
      'customers',
      [
        {
          Id: this.customerId,
          ...this.customer
        }
      ],
      resultFunc);
  }

  onChangeDetails = ({propertyName}) => {
    this.updateDetails(() => this.alert.success(`<b>${propertyName}</b> has been successfully updated`));
  }

  onSalesForceLinkClick = ({propertyValue}) => {
    if (propertyValue) this.goToLink(propertyValue);
  }

  onVerify = () => {
    if (!this.customer.IsVerified) {
      this.modal.show(ConfirmModalComponent, {
        initialState: {
          message: `Are you sure you want to mark <b>${this.customer.Name}</b> as verified?`,
          callback: (result: string) => {
            if (result == 'yes') {
              this.verify();
            }
          }
        }
      });
    } else {
      this.verify();
    }
  }

  verify = () => {
    this.customer.IsVerified = true;
    this.updateDetails(() => this.alert.success(`The customer <b>${this.customer.Name}</b> has been successfully verified`));
  }

  isTestEvironment = () => this.environment.environment === 'test';

}
